import GEFlipTracker from './GEFlipTracker';

function App() {
  return <GEFlipTracker />;
}

export default App;
